


















import { defineComponent, ref, computed, PropType, onMounted, onBeforeUnmount } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';

type Size = 'extra-small' | 'small' | 'medium' | 'large';

export default defineComponent({
  components: {
    AppIcon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<Size>,
      default: 'small',
    },
    isContent: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const initializing = ref(true);
    const heartSizeClass = computed(() => {
      switch (props.size) {
        case 'large':
          return 'w-8 h-8';
        case 'medium':
          return 'w-6 h-6';
        case 'extra-small':
          return 'w-4 h-4';
        default:
          return 'w-5 h-5';
      }
    });

    onMounted(() => {
      // mount時CSSアニメーション走らせないために初回アニメーション終了後フラグ切り替え
      setTimeout(() => {
        initializing.value = false;
      }, 800);
    });

    onBeforeUnmount(() => {
      initializing.value = true;
    });

    return {
      heartSizeClass,
      initializing,
    };
  },
});
